(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/components/advertising.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/components/advertising.js');
'use strict';

const {
  Fieldset
} = svs.ui.reactForm;
const {
  TopHeader
} = svs.myProfile.react.shared.components;
const {
  titles,
  icons
} = svs.myProfile.constants;

const Advertising = _ref => {
  let {
    children
  } = _ref;
  return React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(TopHeader, {
    icon: icons.NEWS,
    title: titles.NEWS
  }), React.createElement("h3", {
    className: "h3 margin-bottom-1"
  }, React.createElement("span", {
    className: "f-medium"
  }, titles.LUCK)), React.createElement("p", null, "Vi kan skicka erbjudanden som \xE4r anpassade f\xF6r dig, exempelvis marknadsf\xF6ring av t\xE4vlingar, jackpottar och spel."), React.createElement(Fieldset, {
    legend: titles.LUCK,
    srOnly: true
  }, children));
};
svs.myProfile.react.pages.communicationSettings.communicationSettings.components.Advertising = Advertising;

 })(window);